import sizeGuide1 from '../../assets/img/img_faqs/SizeGuide1.svg'
import sizeGuide2 from '../../assets/img/img_faqs/SizeGuide2.svg'

export default {
    sizeGuide1,
    sizeGuide2
}
